import { useTranslation } from 'react-i18next';

import { EmployerContributionBoxStyled } from './EditContributionDrawerStyled';
import { convertCurrency } from 'enrollment/utils';

interface EmployerContributionFormProps {
  employerContribution: number;
  employerLumpSum: number;
  id: number;
}

export const EmployerContributionForm: React.FC<
  EmployerContributionFormProps
> = ({ employerContribution, employerLumpSum, id }) => {
  const { t } = useTranslation('pages.financial');
  const isScreenSmall = window.innerWidth < 821;
  return (
    <EmployerContributionBoxStyled className={`employer-contribution-form p-3 ${!isScreenSmall && "mx-2"}`}>
      <h4 className="mb-4">{t('editContribution.employerContribution')}</h4>
      <div>
        <div
          id={`employer-lumpsum-${id}`}
          className="d-flex justify-content-between"
        >
          <span>{t('editContribution.employerLumpSum')}</span>
          <span className="semiBold">
            {convertCurrency(employerLumpSum.toString())}
          </span>
        </div>
        <div
          id={`employer-contribution-${id}`}
          className="d-flex justify-content-between my-3"
        >
          <span>{t('editContribution.employerContribution')}</span>
          <span className="semiBold">
            {convertCurrency(employerContribution.toString())}
          </span>
        </div>
      </div>
    </EmployerContributionBoxStyled>
  );
};
